
       <router-outlet></router-outlet>
       <app-pwa-install></app-pwa-install>
       <app-pwa-install-prompt></app-pwa-install-prompt>
       <vd-ai-bubble></vd-ai-bubble>
       <vd-document-scan-bubble></vd-document-scan-bubble>
       <vd-onboarding-bubble></vd-onboarding-bubble>
       <vd-softphone-widget></vd-softphone-widget>
       <!-- Guide video contextuel : au niveau racine pour couvrir TOUTES les
            pages mappees dans le manifest, y compris hors layout home
            (ex: /CompleteSignUp). Fail-soft sans manifest. -->
       <vd-guide-bubble></vd-guide-bubble>
       <!-- Consentement marketing (Meta Pixel uniquement — Umami cookieless
            n'en a pas besoin). Ne s'affiche que si un pixel est configuré
            pour le domaine (cf. /_a/loader.js) et sans choix mémorisé. -->
       <vd-consent-banner></vd-consent-banner>
       <vd-app-loader></vd-app-loader>

  